import React from "react";
import './Body13.css';
import {Link} from "react-router-dom"
import picture252 from './source/picture252.png'
import picture253 from './source/picture253.png'
import picture254 from './source/picture254.png'
import picture255 from './source/picture255.png'
import picture256 from './source/picture256.png'
import picture257 from './source/picture257.png'




function Body13() {

  return (
    <div className="body13">
      <div className="body13-box1">
        <div className="body13-box2">
          <div className="body13-box3">Buchlovice</div>
          <div className="body13-box5"><div className="body13-box4"></div></div>
          <div className="body13-box6">
          <img className="body13-box6-picture" src={picture252} alt="picture1"/>
          <img className="body13-box6-picture" src={picture253} alt="picture1"/>
          <img className="body13-box6-picture" src={picture254} alt="picture1"/>
          <img className="body13-box6-picture2" src={picture255} alt="picture1"/>
          <img className="body13-box6-picture2" src={picture256} alt="picture1"/>
          <img className="body13-box6-picture2" src={picture257} alt="picture1"/>
          </div>
          <div className="body13-box8"><div className="body13-box7"><Link to="/PageProjekty">Zpět</Link></div></div>
        </div> 
      </div> 
    </div>
  );
}

export default Body13;
